const SvgNavigation = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24">
    <path fill="#1C1B1F" d="m13.554 21-2.979-7.538-7.51-3.054L3 9.888 21 3l-6.928 18zm.259-1.884L19.446 4.56 4.878 10.148l6.345 2.6z" />
  </svg>;
export default SvgNavigation;